__turbopack_context__.v({
  "disabled": "6529Gradient-module-scss-module__Oh12xa__disabled",
  "gap": "6529Gradient-module-scss-module__Oh12xa__gap",
  "gradientTable": "6529Gradient-module-scss-module__Oh12xa__gradientTable",
  "marketplace": "6529Gradient-module-scss-module__Oh12xa__marketplace",
  "nextPreviousNft": "6529Gradient-module-scss-module__Oh12xa__nextPreviousNft",
  "nftNextdisabled": "6529Gradient-module-scss-module__Oh12xa__nftNextdisabled",
  "nftPreviousdisabled": "6529Gradient-module-scss-module__Oh12xa__nftPreviousdisabled",
  "sort": "6529Gradient-module-scss-module__Oh12xa__sort",
  "sortDirection": "6529Gradient-module-scss-module__Oh12xa__sortDirection",
  "transactionsScrollContainer": "6529Gradient-module-scss-module__Oh12xa__transactionsScrollContainer",
  "transactionsTable": "6529Gradient-module-scss-module__Oh12xa__transactionsTable",
});
